// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import {Trans} from 'react-i18next';
import {img_url} from './img_url';
import cn from 'classnames';
import hopt from 'hola_opt';
import styles from './trustpilot.module.less';

export const Trustpilot = ({dark, two_lines, adaptive, column}:{dark?: boolean,
    two_lines?: boolean, adaptive?: boolean, column?: boolean})=>{
    return <a className={cn(styles.root, two_lines && styles.two_lines,
      adaptive && styles.adaptive, dark && styles.dark,
      column && styles.column)}
      target="_blank" rel="noopener noreferrer"
      href="https://www.trustpilot.com/review/hola.org">
      <img src={img_url(`trustpilot/trustpilot${dark ? '_white' : ''}.svg`)}
        alt="Trustpilot" className={cn(styles.f_img, 'lazyload')}/>
      <div className={styles.line_2}>
        <img src={img_url('trustpilot/trustpilot_stars_4_5.svg')} alt="Stars"
          className={cn(styles.s_img, 'lazyload')}/>
        <b>{hopt.trustpilot_rating}{' '}</b><Trans>out of</Trans> 5
      </div>
    </a>;
};
